var map = {
	"./client/pages/404.vue": 58939,
	"./client/pages/admin/acl/index.vue": 65448,
	"./client/pages/admin/config/edit/[entryKey].vue": 19736,
	"./client/pages/admin/config/index.vue": 79362,
	"./client/pages/admin/conversation/message/index.vue": 25573,
	"./client/pages/admin/conversations.vue": 32597,
	"./client/pages/admin/entity/[entityType]/create.vue": 30580,
	"./client/pages/admin/entity/[entityType]/edit/[entityId].vue": 11203,
	"./client/pages/admin/entity/[entityType]/index.vue": 48277,
	"./client/pages/admin/entity/index.vue": 31165,
	"./client/pages/admin/index.vue": 52726,
	"./client/pages/admin/language/index.vue": 34614,
	"./client/pages/admin/media/index.vue": 17790,
	"./client/pages/admin/my/conversation.vue": 59142,
	"./client/pages/admin/order/index.vue": 87083,
	"./client/pages/admin/product/create.vue": 9159,
	"./client/pages/admin/product/edit/[id].vue": 50665,
	"./client/pages/admin/product/index.vue": 70930,
	"./client/pages/admin/user/action/index.vue": 74008,
	"./client/pages/admin/user/index.vue": 90398,
	"./client/pages/admin/vendor/create.vue": 10001,
	"./client/pages/admin/vendor/edit/[id].vue": 36933,
	"./client/pages/admin/vendor/index.vue": 27548,
	"./client/pages/error/index.vue": 20616,
	"./client/pages/error/unauthorized.vue": 76289,
	"./client/pages/index.vue": 58281,
	"./client/pages/notifications/index.vue": 28009,
	"./client/pages/payments-playground.vue": 16680,
	"./client/pages/store/checkout/complete/index.vue": 66604,
	"./client/pages/store/checkout/index.vue": 29036,
	"./client/pages/store/checkout/orderComplete.vue": 61488,
	"./client/pages/store/checkout/orderpg.vue": 51831,
	"./client/pages/store/checkout/standard.vue": 22843,
	"./client/pages/store/index.vue": 12053,
	"./client/pages/store/product/[productId].vue": 77750,
	"./client/pages/store/vendor/[id].vue": 19880,
	"./client/pages/store/vendor/[vendorId].vue": 38544,
	"./client/pages/store/vendor/index.vue": 55884,
	"./client/pages/styleguide.vue": 86738,
	"./client/pages/styleguide/index.vue": 29577,
	"./client/pages/user/activation.vue": 12266,
	"./client/pages/user/dashboard/conversations.vue": 95347,
	"./client/pages/user/dashboard/dashboard.vue": 54544,
	"./client/pages/user/dashboard/help.vue": 21917,
	"./client/pages/user/dashboard/notifications.vue": 78600,
	"./client/pages/user/dashboard/orders.vue": 24485,
	"./client/pages/user/dashboard/payments.vue": 57789,
	"./client/pages/user/dashboard/profile.vue": 5138,
	"./client/pages/user/dashboard/reviews.vue": 58662,
	"./client/pages/user/dashboard/vendor/dashboard.vue": 77738,
	"./client/pages/user/dashboard/vendor/orders.vue": 24093,
	"./client/pages/user/dashboard/vendor/products.vue": 35492,
	"./client/pages/user/dashboard/vendor/profile.vue": 13665,
	"./client/pages/user/dashboard/vendor/reviews.vue": 65540,
	"./client/pages/user/login.vue": 13851
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19735;